module.exports = __webpack_public_path__ + "img/logo.e923ff5d.svg";